(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lg-claims"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function count(el) {
      var m = /^(\d+(?:\.\d+)?)(g|%)?$/.exec(el.textContent.trim());
      if (!m) return;
      var end = parseFloat(m[1]), dec = (m[1].split('.')[1] || '').length, unit = m[2] || '', t0 = null, final = el.textContent;
      el.style.width = el.getBoundingClientRect().width + 'px';
      function step(t) {
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / 1200), e = 1 - Math.pow(1 - p, 3);
        el.textContent = p < 1 ? (end * e).toFixed(dec) + unit : final;
        if (p < 1) requestAnimationFrame(step); else el.style.width = '';
      }
      requestAnimationFrame(step);
    }
    function dots(grid) {
      var cards = [].slice.call(grid.children);
      if (cards.length < 2) return;
      var nav = document.createElement('div'), cur = -1, tick = 0;
      nav.className = 'lg-claimdots';
      cards.forEach(function (c, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Card ' + (i + 1) + ' of ' + cards.length);
        b.addEventListener('click', function () { grid.scrollTo({ left: c.offsetLeft - cards[0].offsetLeft, behavior: calm ? 'auto' : 'smooth' }); });
        nav.appendChild(b);
      });
      grid.parentNode.insertBefore(nav, grid.nextSibling);
      function mark() {
        tick = 0;
        var x = grid.scrollLeft + cards[0].offsetLeft, best = 0, d = Infinity;
        if (grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2) best = cards.length - 1;
        else cards.forEach(function (c, i) { var k = Math.abs(c.offsetLeft - x); if (k < d) { d = k; best = i; } });
        if (best === cur) return;
        cur = best;
        [].forEach.call(nav.children, function (b, i) { if (i === best) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
      }
      grid.addEventListener('scroll', function () { if (!tick) tick = requestAnimationFrame(mark); }, { passive: true });
      mark();
    }
    function init(root) {
      (root || document).querySelectorAll('[data-lg-stats]:not(.is-js)').forEach(function (grid) {
        grid.classList.add('is-js');
        dots(grid);
        function show() { grid.classList.add('is-in'); if (!calm) grid.querySelectorAll('[data-lg-count]').forEach(count); }
        if (calm || !('IntersectionObserver' in window)) { show(); return; }
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); show(); } });
        }, { threshold: 0.12 });
        io.observe(grid);
      });
      (root || document).querySelectorAll('[data-lg-swipe]:not(.is-sw)').forEach(function (grid) { grid.classList.add('is-sw'); dots(grid); });
    }
    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lg-compare"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function count(el) {
      var m = /^(\d+(?:\.\d+)?)(g|%)?$/.exec(el.textContent.trim());
      if (!m) return;
      var end = parseFloat(m[1]), dec = (m[1].split('.')[1] || '').length, unit = m[2] || '', t0 = null, final = el.textContent;
      function step(t) {
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / 900), e = 1 - Math.pow(1 - p, 3);
        el.textContent = p < 1 ? (end * e).toFixed(dec) + unit : final;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    function init(root) {
      (root || document).querySelectorAll('[data-lg-cmp]:not(.is-js)').forEach(function (box) {
        var chips = box.previousElementSibling;
        box.classList.add('is-js');
        if (chips && chips.classList.contains('lg-cmp__chips')) {
          chips.hidden = false;
          chips.addEventListener('click', function (ev) {
            var b = ev.target.closest('.lg-cmp__chip');
            if (!b) return;
            chips.querySelectorAll('.lg-cmp__chip').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
            box.setAttribute('data-col', b.getAttribute('data-col'));
            box.classList.remove('is-swap'); void box.offsetWidth; box.classList.add('is-swap');
          });
        }
        function show() {
          box.classList.add('is-in');
          if (!calm) box.querySelectorAll('.lg-cmp__v').forEach(count);
        }
        if (calm || !('IntersectionObserver' in window)) { show(); return; }
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); show(); } });
        }, { threshold: 0.25 });
        io.observe(box);
      });
    }
    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lg-pdp-facts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-lg-comp]:not(.is-js)').forEach(function (el) {
        el.classList.add('is-js');
        if (!('IntersectionObserver' in window)) { el.classList.add('is-in'); return; }
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); el.classList.add('is-in'); } });
        }, { threshold: 0.5 });
        io.observe(el);
      });
    }
    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lg-versus"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-lg-vs]:not(.is-js)').forEach(function (el) {
        el.classList.add('is-js');
        if (!('IntersectionObserver' in window)) { el.classList.add('is-in'); return; }
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); el.classList.add('is-in'); } });
        }, { threshold: 0.25 });
        io.observe(el);
      });
    }
    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
